const obj = {
    number(num, { inputProps }) {
        const { min, max } = inputProps;

        if (num === "")
            return num;

        if (num < min)
            return min;
        if (num > max)
            return max;

        return num;
    },

    capitalize(str) {
        return str.toString().charAt(0).toUpperCase() + str.toString().slice(1);
    },

    phone(num) {
        /*if (num?.length < 2)
            return "+7";*/
        if (num && num.length === 1 && num[0] === "+")
            return "";

        if (num && num.length === 2 && !(num[0] === "+" && num[1] === "7"))
            num = "7 " + num;

        let str = "+" + num.replace(/[^0-9\s]/g, "").replace(/\s+/g, " ").slice(0, 15);
        const count = str.split(" ").length;

        if (str.length > 2 && count < 2)
            str = str.slice(0, 2) + " " + str.slice(2);
        if (str.length > 6 && count < 3)
            str = str.slice(0, 6) + " " + str.slice(6);
        if (str.length > 10 && count < 4)
            str = str.slice(0, 10) + " " + str.slice(10);
        if (str.length > 13 && count < 5)
            str = str.slice(0, 13) + " " + str.slice(13);

        return str;
    },

    formatTime(time) {
        let cleanTime = time.replace(/[^0-9:]/g, "");

        if (cleanTime?.length > 5)
            return cleanTime.slice(0, 5);

        const count = cleanTime.split(":").length;

        if (cleanTime.length > 2 && count < 2)
            cleanTime = cleanTime.slice(0, 2) + ":" + cleanTime.slice(2);

        return cleanTime;
    },

    date(inputDate) {
        if (!inputDate)
            return "";

        let str = inputDate.replace(/[^0-9.]/g, '').slice(0, 10);
        const count = str.split(".").length;

        if (str.length > 2 && count < 2)
            str = str.slice(0, 2) + "." + str.slice(2);
        if (str.length > 5 && count < 3)
            str = str.slice(0, 5) + "." + str.slice(5);

        if (str.length === 10) {
            let [day, month, year] = str.split(".");
            day = parseInt(day, 10);
            month = parseInt(month, 10);
            year = parseInt(year, 10);

            if (isNaN(day) || day < 1 || day > 31)
                day = "";
            else if (day < 10 && day.length < 2)
                day = "0" + day;

            if (isNaN(month) || month < 1 || month > 12)
                month = "";
            else if (month < 10 && month.length < 2)
                month = "0" + month;

            if (isNaN(year) || year < 1900 || year > new Date().getFullYear())
                year = "";
            else if (year >= 0 && year <= 99)
                year = 2000 + year;

            if (month === 2 && day > 29)
                day = 29;

            if ((month === 4 || month === 6 || month === 9 || month === 11) && day > 30)
                day = 30;

            if (!day || !month || !year)
                str = "";
        }

        return str;
    },

    format(value, { format }) {
        if (!value)
            return "";

        const str = value.slice(0, format.length);

        let strOut = "";
        for (let i = 0; i < str.length; i++) {
            if (format[i] === "x") {
                if (/^[0-9]$/.test(str[i]))
                    strOut += str[i];
            } else if (/^[0-9]$/.test(str[i])) {
                strOut += format[i] + str[i];
            } else if (format[i] === str[i]) {
                strOut += format[i];
            }
        }
        return strOut;
    }

};

export default obj;
